module.exports = __webpack_public_path__ + "img/profile_pic.5feff2ba.svg";